/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import guidebookContentStyle from "../guidebookContentStyle";
import TextContainer from "../../Container/TextContainer";
import Layout from "../../../containers/Layouts/Layout";
import TeaserSlogan from "../../Teaser/TeaserSlogan";
import QuestionsContactSection from "../QuestionsContactSection/QuestionsContactSection";
import DoubleButton from "../../Button/DoubleButton";
import { Helmet } from "react-helmet-async";
import backgroundTeaser from "../../../assets/img/guidebook/Teaser_3-Jahre-Trennung_700px.jpg";
import Typography from "@mui/material/Typography";
import { Paper } from "@mui/material";
import { gaSet } from "../../../services/googleAnalyticsService";

const GuidebookDivorceThreeYearsSeparation = () => {
  const title = "Ratgeber - Scheidung nach mehr als 3 Jahren Trennung | Legalbird";

  gaSet({ title: title });

  return (
    <Layout backgroundType={"serviceworld"}>
      <Helmet>
        <title>{title}</title>
        <meta
          name="description"
          content="Sie leben länger als drei Jahre von Ihrem Ex-Partner getrennt? Warum das die Durchführung der Scheidung
            erleichtert, erfahren Sie hier."
        />
      </Helmet>

      <Paper sx={guidebookContentStyle.paper}>
        <TeaserSlogan
          slogan={"Scheidung nach mehr als 3 Jahren Trennung"}
          backgroundImagePath={backgroundTeaser}
          height={300}
          headingColor={"#333333"}
        />
        <TextContainer>
          <p>Sie leben länger als drei Jahre von Ihrem Ex-Partner getrennt? Warum das die Durchführung der Scheidung erleichtert, erfahren Sie hier.</p>
          <hr />
          <Typography variant={"h4"} sx={guidebookContentStyle.subheader}>
            Nach 3 Jahren Trennung gilt eine Ehe als gescheitert
          </Typography>
          <p>
            Wenn Sie und Ihr Ehepartner mehr als 3 Jahre getrennt voneinander leben, gilt die Ehe per Gesetz automatisch als gescheitert. Dem Gericht muss daher
            nur dargelegt werden, dass Sie und Ihr Ehepartner seit 3 Jahren getrennt leben. Auf den Grund der Scheidung kommt es in diesem Fall dann nicht mehr
            an. Wichtig zu wissen: Nach 3 Jahren Trennung wird die Ehe auch geschieden, wenn Ihr Ehepartner der Scheidung widerspricht.
          </p>
          <Typography variant={"h4"} sx={guidebookContentStyle.subheader}>
            Ihre Scheidung
          </Typography>
          <p>
            Sie möchten sich so unkompliziert und günstig wie möglich scheiden lassen? Sie können hier ganz einfach alle Angaben zu Ihrer Scheidung online
            eingeben, wir erstellen den Scheidungsantrag und reichen Ihn bei Gericht für Sie ein.
          </p>
          <DoubleButton buttonText={"zum Scheidungsantrag"} buttonLink={"/servicewelt"} backText={"Zurück zum Ratgeber"} backLink={"/ratgeber/familienrecht"} />
          <QuestionsContactSection />
        </TextContainer>
      </Paper>
    </Layout>
  );
};

export default GuidebookDivorceThreeYearsSeparation;
